import React from "react";
import _ from "lodash";
import styled from "styled-components";
import moment from "moment";
import { connect } from "formik";
import { DatePicker } from "components/Global/FastFormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const StyleDatePicker = styled(DatePicker)`
  && {
    width:100%;
  }
`;
const SideLabelDateInput = ({ label, fieldName, placeholder, formik, isDisabled, shouldHideForQuote, isIndented, hasBorder, isShort, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }

  const { values } = formik;
  const val = _.get(values, fieldName);

  return (
    <LateralField hasBorder={hasBorder && !isShort} label={label} shouldIndent={Boolean(isIndented)}>
      {isDisabled && <ViewOnlyDiv style={{ borderBottom: `${hasBorder && Boolean(isShort) ? "1px solid gainsboro" : ""}`, paddingRight: "20px", paddingLeft: "20px" }}>{val ? moment(val).format("MM/DD/YYYY") : "--"}</ViewOnlyDiv>}
      {!isDisabled && <StyleDatePicker
        style={{ borderBottom: `${hasBorder && Boolean(isShort) ? "1px solid gainsboro" : ""}`, paddingRight: "20px", paddingLeft: "20px" }}
        fieldName={fieldName}
        placeholder={placeholder}
        {...otherProps}
      />}
      {otherProps.auxComponent}
    </LateralField>
  );
};
export default connect(SideLabelDateInput);
